import { render } from "./ForgetPsw.vue?vue&type=template&id=6acbcad2&scoped=true"
import script from "./ForgetPsw.vue?vue&type=script&lang=js"
export * from "./ForgetPsw.vue?vue&type=script&lang=js"

import "./ForgetPsw.vue?vue&type=style&index=0&id=6acbcad2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acbcad2"],['__file',"src/views/Login/ForgetPsw.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6acbcad2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6acbcad2', __exports__)) {
    api.reload('6acbcad2', __exports__)
  }
  
  module.hot.accept("./ForgetPsw.vue?vue&type=template&id=6acbcad2&scoped=true", () => {
    api.rerender('6acbcad2', render)
  })

}


export default __exports__